import { render, staticRenderFns } from "./BoxIndicadoresConformidade.vue?vue&type=template&id=99a33150&scoped=true&"
import script from "./BoxIndicadoresConformidade.vue?vue&type=script&lang=js&"
export * from "./BoxIndicadoresConformidade.vue?vue&type=script&lang=js&"
import style0 from "./BoxIndicadoresConformidade.vue?vue&type=style&index=0&id=99a33150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a33150",
  null
  
)

export default component.exports